import { Controller } from "@hotwired/stimulus"

// Select-all plus a live count for a table of checkboxes that submits one
// bulk action. Keeps the submit button disabled until something is selected,
// so an empty submit never reaches the server.
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "submit", "count"]
  static values = { selectedLabel: String }

  connect() {
    this.update()
  }

  toggleAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = this.selectAllTarget.checked
    })
    this.update()
  }

  update() {
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked).length

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = selected === 0
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = selected === 0 ? "" : `${selected} ${this.selectedLabelValue}`
    }

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = selected > 0 && selected === this.checkboxTargets.length
      this.selectAllTarget.indeterminate = selected > 0 && selected < this.checkboxTargets.length
    }
  }
}
